import {
  LEGACY_ACTION_TYPES,
  LegacyActionType,
  LegacyCases
} from "@cmodules/checklist/redux/reducers/actions/legacy"
import { SELECT_ITEM_ACTION_TYPES, SelectItemActionType, SelectItemCases } from "./checklist-builder-select-item"
import {
  SUB_TEMPLATE_ACTION_TYPES,
  SubTemplateActionType,
  SubTemplateCases
} from "@cmodules/checklist/redux/reducers/actions/sub-template"

export const cases = {
  ...LegacyCases,
  ...SelectItemCases,
  ...SubTemplateCases
}

export const CHECKLIST_STORE_ACTION_TYPES = {
  ...LEGACY_ACTION_TYPES,
  ...SELECT_ITEM_ACTION_TYPES,
  ...SUB_TEMPLATE_ACTION_TYPES
}

export type ActionType = LegacyActionType | SelectItemActionType | SubTemplateActionType
